import widgetString from "../../public/widget.js?raw";
import {
  DEFAULT_ETEXT_WIDGET_TEST_CONFIG,
  type EtextWidgetTestConfig,
  type EtextWidgetType,
} from "./etextWidgetTestConfig";

const renderFunctionForType = (widgetType: EtextWidgetType): string =>
  widgetType === "feedback" ? "renderFeedbackWidget" : "renderMCQWidget";

export const createIntegrationsFunc =
  (testConfig: EtextWidgetTestConfig) =>
  (screenId: string) => ({
    jsContent: [widgetString],
    onScriptLoad: (apply: Function) => {
      apply(`document.body.innerHTML += "<a href='' data-id=${screenId} id=${screenId}></a>";`);
      const renderFn = renderFunctionForType(testConfig.widgetType);
      apply(`${renderFn}(${JSON.stringify(screenId)}, ${JSON.stringify(testConfig.payload)})`);
    },
  });

export const integrationsFunc = createIntegrationsFunc(DEFAULT_ETEXT_WIDGET_TEST_CONFIG);
